import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import { getOverviewPropertiesOperations } from '@/store/slices/components/dashboard/service';
import GenericBarChart from '../../../Charts/GenericBarChart';
import { getPropertiesSearchParams } from '@/components/Dashboard/DashboardPendings/utils';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import PropertyIcon from '@/public/images/dashboard/property.svg';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';

export default function PropertiesOperations() {
  const dispatch = useDispatch();
  const { overviewPropertiesOperations, miniCards } = useSelector(
    (state) => state.DashboardSlice
  );
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const track = useTrackOverviewTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const { loading, hasFetched, labels, datasets } =
    overviewPropertiesOperations;
  const { selectedStatusId: statusId, propertiesValue } = miniCards;

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewPropertiesOperations({ query, statusId }));
    },
    [statusId],
    { hasFetched }
  );

  const getHeaderUrl = () => {
    const searchParams = getPropertiesSearchParams({
      statusId,
      selectedIds,
    });

    return `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
  };

  const handleClickBar = ({ label }) => {
    const { operationId } = label;
    const searchParams = getPropertiesSearchParams({
      operation_types: [operationId],
      statusId,
      selectedIds,
    });

    const url = `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
    window.open(url, '_blank');
  };

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={propertiesValue === 0 ? null : getHeaderUrl()}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.propertyOperation(element)}
      >
        {Trans(translations, 'Operation')}
      </PendingCard.Header>
      {propertiesValue === 0 ? (
        <DashboardEmptyStateCard
          icon={PropertyIcon}
          title={Trans(
            translations,
            'HereYouWillSeeTheNumberOfPropertiesForEachOperationType'
          )}
        />
      ) : (
        <GenericBarChart
          labels={labels}
          datasets={datasets}
          onBarClick={selectedIds.length > 1 ? null : handleClickBar}
        />
      )}
    </PendingCard>
  );
}
